/**
 * Name of the "bypass maintenance" header.
 */
export const MAINTENANCE_MODE_BYPASS_HTTP_HEADER_NAME = "X-Maintenance-Bypass"